import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { ApiError } from '@app/services/api.types';
import type { AIFlowListParams, AIFlowListResponse } from '@app/services/aiFlow.types';

type QueryOptions = Omit<UseQueryOptions<AIFlowListResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchFlowList = async (params: AIFlowListParams): Promise<AIFlowListResponse> => {
    const url = apiEndpoints.aiFlows.getList(params);
    const response = await api.get(url);
    return response?.data?.data;
};

const useFlows = (params: AIFlowListParams, options?: QueryOptions) => {
    return useQuery<AIFlowListResponse, ApiError>({
        queryKey: ['ai-flow', 'list', params],
        queryFn: () => fetchFlowList(params),
        ...options,
    });
};

export default useFlows;
